export default "__VITE_ASSET__C6023JJ$__"